<template>
    <FsLightbox
        v-if="modelValue"
        :key="key"
        :sources="sources"
        :toggler="toggler"
        exit-fullscreen-on-close
        v-bind="$attrs"
        class="!m-0"
        @close="onClose"
        @vue:mounted="onMounted"
    />
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent, type PropType } from 'vue';

/**
 * Wrapper for fslightbox-vue to dynamically load it for better performance.
 * See https://fslightbox.com/vue/documentation
 */
export default defineComponent({
    name: 'Lightbox',
    components: {
        // @ts-ignore fslightbox-vue/v3 is not typed
        FsLightbox: defineAsyncComponent(() => import('fslightbox-vue')),
    },
    inheritAttrs: false,
    props: {
        /**
         * Whether the lightbox is visible.
         */
        modelValue: {
            type: Boolean,
            default: false,
        },
        /**
         * The sources of the lightbox.
         */
        sources: {
            type: Array as PropType<string[]>,
            required: true,
        },
    },
    emits: ['update:modelValue', 'onClose'],
    data() {
        return {
            key: 0,
            toggler: false,
        };
    },
    watch: {
        sources: {
            deep: true,
            handler() {
                // fslightbox does not react to source changes, so we need to re-render it fully
                this.key += 1;
            },
        },
    },
    methods: {
        onClose() {
            this.$emit('update:modelValue', false);
            // eslint-disable-next-line vue/custom-event-name-casing -- matching the fslightbox event name
            this.$emit('onClose');
        },
        onMounted() {
            // although fslightbox can be opened on mount, it would always show the first source
            // so we need to toggle it via the toggler to open the lightbox
            this.toggler = !this.toggler;
        },
    },
});
</script>
